import { gql } from '@apollo/client';

export default gql`
  mutation redeemBusinessAccountBenefit(
    $businessId: String!
    $membershipNumber: String!
    $benefitName: String!
    $bookingReference: String!
    $carrier: String
    $origin: String
    $destination: String
    $departureDateTime: DateTime
  ) {
    redeemBusinessAccountBenefit(
      businessId: $businessId
      membershipNumber: $membershipNumber
      benefitName: $benefitName
      bookingReference: $bookingReference
      carrier: $carrier
      origin: $origin
      destination: $destination
      departureDateTime: $departureDateTime
    ) {
      success
      activityId
    }
  }
`;
